import React from 'react';
import useHeaderCustomAction from "v4/features/front/header/hooks/useHeaderCustomAction";
import {PolIcon} from "components/PolIcon/policon";
import './HeaderCustomAction.scss';
import Confirm from "v4/components/ui/Confirm/Confirm";
import {usePolTranslation} from "v4/hooks/usePolTranslation";

export default function HeaderCustomAction({customAction}) {
    const {t} = usePolTranslation();
    const {
        isOpen,
        toggleOpen,
        handleAction,
    } = useHeaderCustomAction(customAction);

    return (
        <>
            <button type="button"
                    className="header__custom-action"
                    title={customAction.title}
                    onClick={customAction.confirmBeforeMessage?.length > 0 ? toggleOpen : handleAction}>
                {customAction.imageUrl && <img src={customAction.imageUrl} alt={customAction.title}/>}
                {customAction.icon && <PolIcon icon={customAction.icon}/>}
                {customAction.label && <span>{customAction.label}</span>}
            </button>

            <Confirm isOpen={isOpen}
                     cancelAction={toggleOpen}
                     confirmAction={handleAction}>
                <p>{t(customAction.confirmBeforeMessage)}</p>
            </Confirm>
        </>
    )
}
